<template>
    <div>
        <base-header type="gradient-blue" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col-12 col-md-12 col-lg-8">
                    <h1 class="text-white pt-3 px-3">แสดงข้อมูลแพ็กเกจด่วนทั้งหมด</h1>
                    <p
                        class="text-white pb-0 px-3"
                    >คุณสามารถพิมพ์ใบเสร็จรับเงินแบบจัดส่งด่วน ยกเลิกพัสดุ และดูรายละเอียดการจัดส่งแบบด่วนได้</p>
                </div>
            </div>
        </base-header>
        <div class="text-center" v-if="busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--7 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="row justify-content-between">
                                <div class="col-12">
                                    <h3 class="text-muted">ค้นหา</h3>
                                    <div class="col-lg-12">
                                        <b-form-group class="mb-0">
                                            <div class="row">

                                                <div class="col-lg m-1">
                                                    <date-range-picker
                                                        class="w-100"
                                                        :opens="'center'"
                                                        :min-date="minDate"
                                                        :max-date="maxDate"
                                                        :singleDatePicker="false"
                                                        :appendToBody="true"
                                                        :ranges="false"
                                                        :closeOnEsc="false"
                                                        :autoApply="true"
                                                        :locale-data="{ format: 'dd-mm-yyyy' }"
                                                        v-model="search">
                                                    </date-range-picker>
                                                </div>

                                                <div class="col-lg m-1">
                                                    <select class="form-control" v-model="search.pkgStatus">
                                                        <option value="" disabled selected>กรุณาเลือกสถานะการสั่งซื้อ</option>
                                                        <option :value="item.value" v-for="(item,index) in orderStatus" :key="index">{{item.label}}</option>
                                                    </select>
                                                </div>

                                                <div class="col-lg m-1">
                                                    <input
                                                        type="text"
                                                        placeholder="หมายเลขติดตาม"
                                                        class="form-control"
                                                        v-model="search.expressPkgNum"
                                                    />
                                                </div>
                                                <div class="col-lg m-1">
                                                    <input
                                                        type="text"
                                                        placeholder="หมายเลขผู้ส่ง"
                                                        class="form-control"
                                                        v-model="search.senderPhone"
                                                    />
                                                </div>

                                                <div class="col-lg-2 m-1">
                                                    <button class="btn btn-info btn-sm-res"
                                                            @click="queryListWithoutNoPay()">
                                                        <i class="fa fa-search"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </b-form-group>
                                        <div class="mt-4">
                                            <button class="btn btn-info btn-sm-res"
                                                    @click="batchPrint()"
                                                    :disabled="selected.length == 0">
                                                Print
                                                <i class="fa fa-print"></i>
                                            </button>

                                            <button class="btn btn-info btn-sm-res"
                                                    @click="exportData()">
                                                ส่งออก
                                                <i class="fa fa-file-export"></i>
                                            </button>
                                        </div>
                                        <hr class="d-md-none d-lg-none"/>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-6 col-xl-4 mb-3">
                                        <hr class="d-block d-md-none d-lg-none mb-0"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- table -->
                        <div id="tablePrint">
                            <b-table
                                ref="reportDelivery"
                                show-empty
                                responsive
                                :items="user"
                                :fields="fields"
                                :per-page="search.perPage"
                                :busy="busy"
                                selectable
                                select-mode="multi"
                                @row-selected="onRowSelected"
                                class="scroll-bar-pop text-center"
                                empty-text="ไม่มีข้อมูลผู้ใช้"
                                empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                            >
                                <template slot="HEAD_selected">
                                    <b-form-checkbox v-model="checkSelect" @change="selectAllRows"
                                                     class="text-center"></b-form-checkbox>
                                </template>
                                <template
                                    slot="selected"
                                    slot-scope="{ rowSelected }"
                                >
                                    <template v-if="rowSelected">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" autocomplete="off" class="custom-control-input"
                                                   value="true" checked>
                                            <label class="custom-control-label"></label>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" autocomplete="off" class="custom-control-input"
                                                   value="false">
                                            <label class="custom-control-label"></label>
                                        </div>
                                    </template>
                                </template>
                                <template slot="payStatus" slot-scope="data">
                                    <pkgTag :pkgStatus="data.item.pkgStatus" :payStatus="data.item.payStatus"></pkgTag>
                                </template>
                                <template slot="collectionAddress" slot-scope="data">
                                    <!--                                    <span>{{ data.item.expressPkgNum }}</span>-->
                                </template>
                                <template slot="ShippingInformation" slot-scope="data">
                                    <span>{{ data.item.senderName + '-' + data.item.senderPhone }}</span></br>
                                    <span>{{
                                            data.item.senderAddress + '-' + data.item.senderDistrict + '-' + data.item.senderCity + '-' + data.item.senderProvince + '-' + data.item.senderPostcode
                                        }}</span>
                                </template>
                                <template slot="ReceivingInformation" slot-scope="data">
                                    <span>{{ data.item.receiverName + '-' + data.item.receiverPhone }}</span></br>
                                    <span>{{
                                            data.item.receiverAddress + '-' + data.item.receiverDistrict + '-' + data.item.receiverCity + '-' + data.item.receiverProvince + '-' + data.item.receiverPostcode
                                        }}</span>
                                </template>
                                <template slot="pkgInfo" slot-scope="data">
                                    <span>{{
                                            data.item.pkgWeight + 'kg'
                                        }} {{
                                            data.item.pkgLenght + 'x' + data.item.pkgWidth + 'x' + data.item.pkgHeight + 'cm'
                                        }} COD:{{ data.item.codAmount }}</span></br>
                                    <span>{{
                                            data.item.isSpeed ? '' : 'SPEED'
                                        }} INSURE:{{ data.item.insureAmount }}</span>
                                </template>
                                <template slot="manage" slot-scope="data">
                                    <button class="btn btn-sm btn-info px-3">
                                        <i class="fas fa-file-alt"></i>รายละเอียด
                                    </button>
                                    <button class="btn btn-sm btn-danger px-3" @click="showRevoke(data.item)" v-if="[0, 8, 9, 11, 12].indexOf(data.item.pkgStatus) > -1 && data.item.canCancel && data.item.payStatus === 2">
                                        <i class="fas fa-undo"></i>ยกเลิก
                                    </button>
                                    <button class="btn btn-sm btn-info px-3" @click="printCourierOne(data.item)">
                                        <i class="fas fa-print"></i>พิมพ์
                                    </button>
                                </template>
                            </b-table>
                            <div class="mt-3">
                                <b-pagination
                                    :total-rows="totalItem"
                                    :current-page="search.page"
                                    :per-page="search.perPage"
                                    :value="search.page"
                                    @input="changePage"
                                    align="right">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <b-modal
            centered
            hide-footer
            v-model="revokeFormVisible"
            size="md"
            hide-header
        >
            <div class="row">
                <div class="col-12">
                    <span class="close cursor-pointer" @click="closeModal()">&times;</span>
                </div>
            </div>
            <div class="row text-center">
                <div class="col-lg-12 py-4">
                    <h3>เหตุผลในการยกเลิกคำสั่งซื้อของคุณคือ？</h3>
                </div>
            </div>
            <div>
                <b-form-radio-group v-model="selectedOption">
                    <div v-for="(item, index) in reasonForReturnList" :key="index">
                        <b-form-radio :value="item.id">{{ item.label }}</b-form-radio>
                    </div>
                    <b-form-input v-model="reasonForReturnMessage" trim v-if="selectedOption == 100"
                                  class="mt-2"></b-form-input>
                </b-form-radio-group>
            </div>
            <div class="d-flex justify-content-center mt-4">
                <b-button
                    class="px-5"
                    variant="secondary"
                    @click="closeModal()"
                >
                    ยกเลิก
                </b-button>
                <b-button
                    class="px-5"
                    variant="primary"
                    @click="sure()"
                >
                    ยืนยัน
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {cancelExpressPkg, exportExcelUrl, printPkgWayBillV2, queryListWithoutNoPay} from "@/api/orderList";
import pkgTag from "@/components/custom/pkg-tag.vue";

const API_URL = process.env.VUE_APP_API;
import validatePop from "../../plugins/validatePop.js"
import moment from "moment/moment";

export default {
    name: "fakecustomer",
    components: {
        pkgTag
    },
    data() {
        return {
            orderStatus: [
                {
                    value: 11,
                    label: "ที่จะพิมพ์"
                },
                {
                    value: 12,
                    label: "รอรับ"
                },
                {
                    value: 0,
                    label: "ที่จะจัดสรร"
                },
                {
                    value: 1,
                    label: "หยิบขึ้น"
                },
                {
                    value: 2,
                    label: "ระหว่างทาง"
                },
                {
                    value: 5,
                    label: "ได้รับแล้ว"
                },
                {
                    value: 6,
                    label: "กำลังประมวลผล"
                },
                {
                    value: 7,
                    label: "กลับมาแล้ว"
                },
                {
                    value: 8,
                    label: "การปิดเครื่องผิดปกติ"
                },
                {
                    value: 9,
                    label: "เพิกถอนแล้ว"
                }
            ],
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            filters: {
                startDate: "",
                endDate: ""
            },
            reasonForReturnList: [
                {
                    id: 1,
                    label: "ลูกค้าไม่ต้องการส่งมัน"
                },
                {
                    id: 2,
                    label: "ข้อมูลไม่ถูกต้อง"
                },
                {
                    id: 3,
                    label: "ลูกค้าขอเปลี่ยนเวลา"
                },
                {
                    id: 4,
                    label: "ค่าส่งไม่สมเหตุสมผล"
                },
                {
                    id: 5,
                    label: "ลูกค้าต้องการเปลี่ยนมาใช้บริการจัดส่งด่วน"
                },
                {
                    id: 6,
                    label: "รอนานเกินไปในการรับพัสดุ"
                },
                {
                    id: 7,
                    label: "Courier ขอยกเลิก (ของเถื่อน)"
                },
                {
                    id: 8,
                    label: "เจ้าหน้าที่จัดส่งขอยกเลิก (สินค้าขนาดใหญ่)"
                },
                {
                    id: 9,
                    label: "ระบบผิดพลาด"
                },
                {
                    id: 100,
                    label: "อื่น"
                }
            ],
            reasonForReturnMessage: "",
            selectedOption: "",
            revokeFormVisible: false,
            referrer: '',
            revokeId: '',
            selected: [],
            busy: false,
            checkSelect: false,
            user: [],
            createTypeBy: '',
            search: {
                page: 1,
                perPage: 10,
                startDate: "",
                endDate: "",
                pkgStatus: "",
            },
            totalItem: 0,
            responseFake: {
                status: "",
                tmpKey: "",
                customerId: 0,
                phone: ""
            }
        }
    },
    mounted() {
        this.getDateNow(new Date())
        this.queryListWithoutNoPay()
    },
    methods: {
        getDateNow(myDate) {
            // 当前日期
            var year = myDate.getFullYear();
            var month = ("0" + (myDate.getMonth() + 1)).slice(-2);
            var date = ("0" + myDate.getDate()).slice(-2);
            var formattedDate = year + "-" + month + "-" + date;

            // 前一个月的同一天
            var lastMonthDate = new Date(myDate);
            lastMonthDate.setMonth(myDate.getMonth() - 1);

            // 处理跨年问题
            if (myDate.getMonth() === 0) {
                lastMonthDate.setFullYear(myDate.getFullYear() - 1);
                lastMonthDate.setMonth(11);
            }

            var lastMonthYear = lastMonthDate.getFullYear();
            var lastMonthMonth = ("0" + (lastMonthDate.getMonth() + 1)).slice(-2);
            var lastMonthDay = ("0" + lastMonthDate.getDate()).slice(-2);
            var formattedLastMonthDate = lastMonthYear + "-" + lastMonthMonth + "-" + lastMonthDay;

            // 设置时间区间
            this.search.startDate = formattedLastMonthDate;
            this.search.endDate = formattedDate;
        },
        batchPrint() {
            let ids = this.selected.map(item => item.id)
            printPkgWayBillV2(ids).then(res => {
                window.open(res.data.url)
                this.queryListWithoutNoPay()
            }).finally(() => {
                this.$refs.reportDelivery.clearSelected()
            })
        },
        exportData() {
            let data = {
                agentId: this.$store.state.loginUser.agentId,
                ... this.search,
                exportType: 1,
                routeName: "orderList",
            }
            exportExcelUrl(data).then(res => {
                window.open(res.data)
            })
        },
        sure() {
            if (this.selectedOption == "") {
                this.showErrorModal("กรุณาเลือกเหตุผลในการถอน")
                return
            }
            if (this.selectedOption == 100 && this.reasonForReturnMessage == "") {
                this.showErrorModal("กรุณาระบุเหตุผลในการยกเลิก")
                return
            }
            this.$bvModal
                .msgBoxConfirm(`คุณแน่ใจหรือไม่ว่าต้องการยกเลิกคำสั่งซื้อ？ `, {
                    title: "กรุณายืนยัน",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "ยืนยัน",
                    cancelTitle: "ยกเลิก",
                    //for P' OOOO
                    contentClass: "modal-confirm",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true
                })
                .then(() => {
                    this.busy = true
                    cancelExpressPkg({
                        pkgId: this.revokeId,
                        cancelReason: this.selectedOption == 100 ? this.reasonForReturnMessage : this.reasonForReturnList.find(item => item.id == this.selectedOption).label
                    }).then(res => {
                        this.showSuccessModal("เพิกถอนเรียบร้อยแล้ว")
                        this.queryListWithoutNoPay()
                    }).catch(err => {
                        this.showErrorModal(err.msg)
                    }).finally(() => {
                        this.busy = false
                        this.closeModal()
                    })
                }).catch(() => {
                    this.closeModal()
            })

        },
        closeModal() {
            this.revokeFormVisible = false
            this.selectedOption = ""
            this.reasonForReturnMessage = ""
        },
        showRevoke(row) {
            console.log(row)
            this.revokeId = row.id
            this.referrer = row.referrer
            this.revokeFormVisible = true
        },
        selectAllRows() {
            if(this.user.length < 1){
                return false
            }
            this.checkSelect = !this.checkSelect
            if(this.checkSelect){
                this.$refs.reportDelivery.selectAllRows()
            }else{
                this.$refs.reportDelivery.clearSelected()
            }
        },
        onRowSelected(item) {
            this.selected = item
        },
        queryListWithoutNoPay() {
            this.busy = true
            let data = {
                agentId: this.$store.state.loginUser.agentId,
                ... this.search,
            }
            data.endTime = data.endDate ? moment(data.endDate).format("YYYY-MM-DD") + ' 23:59:59' : ''
            data.startTime = data.startDate ? moment(data.startDate).format("YYYY-MM-DD") + ' 00:00:00' : ''
            queryListWithoutNoPay(data).then(res => {
                console.log(res)
                this.user = res.data.records;
                this.totalItem = res.data.total;
            }).finally(() => {
                this.busy = false
            })
        },

        // 打印单个面单
        async printCourierOne(row) {
            let res = await printPkgWayBillV2([row.id])
            window.open(res.data.url)
            this.queryListWithoutNoPay()
        },

        handleLoader() {
            this.busy = !this.busy
        },
        changePage(i) {
            if (this.search.page == i) return;
            this.search.page = i
            this.queryListWithoutNoPay()
        },
        getOverAllIndex(index) {
            return (this.search.page * 20) - 20 + index + 1
        },
        showSuccessModal(msgBody) {
            this.$bvModal.msgBoxOk(msgBody, {
                title: "SUCCESS",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                okTitle: "ตกลง",
                contentClass: "modal-success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true
            });
        },
        showErrorModal(msgBody, OkmsgTitle = "ลองอีกครั้ง") {
            this.$bvModal.msgBoxOk(msgBody, {
                title: "ERROR",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: OkmsgTitle,
                contentClass: "modal-errors",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true
            });
        },
    },
    computed: {
        checkErrorBeforeSearch() {
            return (this.search.errorShopCode || this.search.errorSACode) == false ? false : true
        },
        fields() {
            let fields = [
                {key: "selected", label: "เลือกรายการ", sortable: false, class: "text-center"},
                {key: "expressPkgNum", label: "หมายเลขใบนำส่งสินค้า", sortable: true},
                {key: "expressCode", label: "บริษัทจัดส่ง", sortable: true},
                {key: "payStatus", label: "สถานะการสั่งซื้อ", sortable: true},
                {key: "expressCode", label: "หมายเลขใบเสร็จรับเงินแคชเชียร์", sortable: true},
                {key: "createTime", label: "เวลาสร้าง", sortable: true},
                {key: "collectionAddress", label: "ที่อยู่ของการรวบรวม", sortable: true},
                {key: "ShippingInformation", label: "ผู้ส่ง", sortable: true},
                {key: "ReceivingInformation", label: "ผู้รับ", sortable: true},
                {key: "pkgInfo", label: "ข้อมูลแพ็คเกจ", sortable: true},
                {key: "manage", label: "จัดการ"}
            ]
            return fields
        }
    }
}
</script>
